import { useCallback } from 'react';
import { useRefresh, useUpdate } from 'react-admin';

interface Params {
  id?: string;
  isCoach?: boolean;
  isCoachUrl: string;
}

export const useToggleIsCoach = ({ isCoach, isCoachUrl, id }: Params) => {
  const refresh = useRefresh();

  const [toggle, { isLoading, error }] = useUpdate(
    isCoachUrl,
    {
      id,
      data: { isCoach: !isCoach },
    },
    {
      onSettled: () => {
        refresh();
      },
    },
  );

  const handleToggleIsCoach = useCallback(() => {
    toggle();
  }, [toggle]);

  return {
    toggle,
    handleToggleIsCoach,
    isLoading,
    error,
  };
};
